import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/ai-transparency-notice.md?raw';

export default function AINoticeScreen() {
  return <LegalDoc markdown={markdown} title="AI Transparency Notice" />;
}
